import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const OsintDisclaimer = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid="back-link"
            className="inline-flex items-center gap-2 text-helix-blue hover:text-helix-blue/80 mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <article className="prose prose-lg max-w-none">
            <h1 data-testid="osint-title" className="text-4xl font-bold text-helix-dark mb-8">
              Disclaimer - Use of Open-Source Intelligence (OSINT) Reports
            </h1>

            <p className="text-gray-600 leading-relaxed mb-6">
              This OSINT report has been prepared in accordance with Australian law and is intended for informational purposes only. While reasonable efforts have been made to ensure the accuracy and reliability of the information provided, the content is derived from publicly available sources, which may contain inaccuracies, omissions, or outdated information.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6">
              The report should not be solely relied upon for making critical decisions. HelixAspire accepts no liability for any loss, damage, or adverse outcomes arising from reliance on this report or its contents. The user acknowledges that OSINT information is subject to interpretation and that its use may involve inherent risks.
            </p>

            <p className="text-gray-600 leading-relaxed">
              Nothing in this disclaimer limits any rights or guarantees that cannot be excluded under Australian law, including those outlined in the Australian Consumer Law (Schedule 2 of the Competition and Consumer Act 2010). By using this report, the user agrees to these terms and assumes full responsibility for any decisions made based on the information contained herein.
            </p>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OsintDisclaimer;
